// [ai-generated-code]
export enum Status {
  DA_INVIARE = 'DA_INVIARE',
  DA_NON_INVIARE = 'DA_NON_INVIARE',
  INVIO_IN_CORSO = 'INVIO_IN_CORSO',
  INVIATO = 'INVIATO',
  ESCLUSO = 'ESCLUSO',
}

export interface GaragePassage {
  id: number;
  reparto: string;
  tipoVendita: string;
  marca: string;
  modello: string;
  targa: string;
  telaio: string;
  dataDocumento: string;
  numeroPratica: number;
  nrBpCliente: number;
  denominazioneCliente: string;
  emailCliente: string;
  codiceFiscaleCliente: string;
  pivaCliente: string;
  consensoMarketing: boolean;
  nrBpUtilizzatore: number;
  denominazioneUtilizzatore: string;
  emailUtilizzatore: string;
  nrBpProprietario: number;
  denominazioneProprietario: string;
  emailProprietario: string;
  nrBpNotizia: number;
  denominazioneNotizia: string;
  emailNotizia: string;
  respCliente: string;
  statoRecord: string;
  respClienteEmail: string;
  respClienteIndirizzoEmail: string;
  modelloEmail: string;
  email: string;
  bpEmail: number;
  denominazioneEmail: string;
  valid: boolean;
  validWhatsapp: boolean;
  rivenditoreEsterno: string;
  telefonoUtilizzatore: string;
  codiceVenditoreInterno: string;
  sentWhatsappDate: string;
  statoConsegnaVgi;
  creator: string;
  created: string;
  modifier: string;
  modified: string;
}

export interface GaragePassageResponse {
  content: GaragePassage[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}
